<script lang="ts" setup>
  import { userAction } from '../../../../shared/observability/userAction.ts';

  defineEmits<{ click: [] }>();
</script>

<template>
  <button
    :data-faro-user-action-name="userAction.gameOverOpenFeedback"
    class="feedback-button"
    type="button"
    @click="$emit('click')"
  >
    feedback
  </button>
</template>

<style scoped>
  .feedback-button {
    background: color-mix(in srgb, var(--color-primary), transparent 90%);
    border: none;
    border-radius: var(--radius-control);
    color: var(--color-primary);
    cursor: pointer;
    font: inherit;
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-strong);
    letter-spacing: 0.05em;
    padding: 0.4rem 0.5rem;
    position: relative;
    text-transform: uppercase;
    white-space: nowrap;

    &::after {
      content: '';
      inset: min(0px, calc((100% - var(--size-touch-target)) / 2));
      position: absolute;
    }

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    &:active {
      transform: scale(0.95);
    }
  }
</style>
